"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const render_1 = __importDefault(require("./render"));
const state_1 = __importDefault(require("../state"));
const update_1 = __importDefault(require("./update/update"));
const tick = () => {
    state_1.default.currentTime += state_1.default.app.ticker.deltaMS;
    (0, update_1.default)();
    (0, render_1.default)();
};
exports.default = tick;
